import axios, { AxiosResponse, AxiosError } from "axios";
import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { IBookmark, IUser } from "../Models/Models";
import * as types from "./Types";

export const setShowBookmarkModal = (setShowBookmarkModal: boolean) => ({
    type: types.SET_SHOW_BOOKMARK_MODAL,
    data: setShowBookmarkModal,
});

export const loadBookmarks: ActionCreator<ThunkAction<any, any, any, any>> = (
    data
) => {
    return (dispatch: Dispatch<any>) => {
        dispatch(setLoadingBookmarks(true));

        axios
            .get("/Users/Bookmarks")
            .then((response) => {
                const bookmarks: IBookmark[] = response.data.data;
                dispatch(loadBookmarksSuccess(response.data.data));
                dispatch(setLoadingBookmarks(false));
                if (bookmarks && bookmarks[0]) {
                    dispatch(setFoundBookmarks(true));
                } else {
                    dispatch(setFoundBookmarks(false));
                }
            })
            .catch((error) => {
                dispatch(loadBookmarksFailure(error));
                dispatch(setLoadingBookmarks(false));
                dispatch(setFoundBookmarks(false));
            });
    };
};

export const setDefaultBookmark: ActionCreator<
  ThunkAction<any, any, any, any>
> = (newDefaultBookmark: IBookmark) => {
    return (dispatch: Dispatch<any>) => {
        dispatch(setLoadingBookmarks(true));

        axios
            .post("/Bookmark/Default", newDefaultBookmark )
            .then((response: AxiosResponse) => {
                dispatch(setDefaultBookmarkSuccess(response.data.data));
                dispatch(setLoadingBookmarks(false));
            })
            .catch((error: AxiosError) => {
                console.log("Failed to set new default bookmark");
                dispatch(setLoadingBookmarks(false));
            });
    };
};

export const deleteBookmark: ActionCreator<ThunkAction<any, any, any, any>> = (
    deletedBookmark: IBookmark
) => {
    return (dispatch: Dispatch<any>) => {
        dispatch(setLoadingBookmarks(true));

        axios
            .delete(`/Bookmark/${deletedBookmark.id}`)
            .then((response: AxiosResponse) => {
                dispatch(deleteBookmarkSuccess(response.data.data));
                dispatch(setLoadingBookmarks(false));
                // calling loadBookmarks to refresh the bookmarks list
                dispatch(loadBookmarks());
            })
            .catch((error: AxiosError) => {
                console.log("Failed to delete bookmark");
                dispatch(setLoadingBookmarks(false));
            });
    };
};

// SUCCESS
const loadBookmarksSuccess = (data: IUser) => ({
    type: types.LOAD_BOOKMARKS_SUCCESS,
    data: data,
});

const setActiveBookmark = (data: IBookmark) => ({
    type: types.SET_ACTIVE_BOOKMARK,
    data: data,
});

const setLoadingBookmarks = (loading: boolean) => ({
    type: types.SET_LOADING_BOOKMARKS,
    data: loading,
});

const setFoundBookmarks = (found: boolean) => ({
    type: types.SET_FOUND_BOOKMARKS,
    data: found,
});

const deleteBookmarkSuccess = (bookmark: IBookmark) => ({
    type: types.DELETE_BOOKMARK_SUCCESS,
    data: bookmark,
});

const setDefaultBookmarkSuccess = (bookmark: IBookmark) => ({
    type: types.SET_DEFAULT_BOOKMARK_SUCCESS,
    data: bookmark,
});

// FAILURE
const loadBookmarksFailure = (data: IUser) => ({
    type: types.LOAD_BOOKMARKS_FAILURE,
    data: data,
});
